export const translationOverrides = {
  en: {
    "CYPRUS PRIVÉ · PERSÖNLICH VOR ORT": "CYPRUS PRIVÉ · PERSONAL SUPPORT, LOCALLY",
    "Immobilien, Unternehmensgründung, Bankkonto und Ihr Neustart: Wir verbinden persönliche Betreuung mit einem Netzwerk spezialisierter Partner – von der ersten Orientierung bis zur Umsetzung.": "Property, company formation, banking and relocation. We bring together personal support and specialist partners — from your first questions to practical steps on the ground.",
    "IHR SERVICE RUND UM NORDZYPERN.": "YOUR SERVICE PARTNER IN NORTH CYPRUS.",
    "IHR SERVICE RUND UM NORDZYPERN": "YOUR SERVICE PARTNER IN NORTH CYPRUS",
    "Ihr Service rund um Nordzypern.": "Your service partner in North Cyprus.",
    "Ihr Service rund um Nordzypern": "Your service partner in North Cyprus",
    "Ankommen. Entdecken. Entscheiden.": "Arrive. Discover. Decide.",
    "UNSERE SERVICES ENTDECKEN": "EXPLORE OUR SERVICES",
    "PERSÖNLICHES GESPRÄCH": "LET’S TALK",
    "Investments nur auf Anfrage.": "Investments by request only.",
    "Individuelle Konditionen.": "Individually agreed terms.",
    "Investments ausschließlich auf Anfrage.": "Investments exclusively on request.",
    "Ausschließlich auf Anfrage.": "Exclusively on request.",
    "AUF ANFRAGE": "ON REQUEST",
    "Individuell abgestimmte Konditionen.": "Individually agreed terms.",
    "Auf Anfrage · individuelle Konditionen": "On request · individual terms",
    "Immobilien": "Property",
    "Firmengründung": "Company Formation",
    "Bankkontoeröffnung": "Bank Account Opening",
    "Banking": "Banking",
    "Relocation": "Relocation",
    "Angebote": "Packages",
    "Ratgeber": "Guide",
    "Nordzypern kennenlernen": "Discover North Cyprus",
    "Internationaler Umzugsservice": "International Relocation",
    "SETUP-CHECK": "SETUP CHECK",
    "Kennenlern-Aufenthalt planen": "Plan your discovery stay",
    "Ein Ansprechpartner.": "One point of contact.",
    "Spezialisten für jeden Bereich.": "Specialists for every step.",
    "Services": "Services",
    "Immobilien kennenlernen": "Explore property options",
    "Gründung besprechen": "Discuss company formation",
    "Banking anfragen": "Enquire about banking",
    "Neustart planen": "Plan your move",
    "ANFRAGE SENDEN": "SEND ENQUIRY",
    "Vielen Dank für Ihre Anfrage.": "Thank you for your enquiry.",
    "Investments.": "Investments.",
    "Home": "Home",
    "Close": "Close"
  },
  tr: {
    "CYPRUS PRIVÉ · PERSÖNLICH VOR ORT": "CYPRUS PRIVÉ · YERİNDE KİŞİSEL DESTEK",
    "Immobilien, Unternehmensgründung, Bankkonto und Ihr Neustart: Wir verbinden persönliche Betreuung mit einem Netzwerk spezialisierter Partner – von der ersten Orientierung bis zur Umsetzung.": "Gayrimenkul, şirket kuruluşu, banka hesabı ve taşınma: İlk değerlendirmeden uygulamaya kadar, size özel desteği uzman iş ortaklarımızla buluşturuyoruz.",
    "IHR SERVICE RUND UM NORDZYPERN.": "KUZEY KIBRIS'TAKİ HİZMET ORTAĞINIZ.",
    "IHR SERVICE RUND UM NORDZYPERN": "KUZEY KIBRIS'TAKİ HİZMET ORTAĞINIZ",
    "Ihr Service rund um Nordzypern.": "Kuzey Kıbrıs'taki hizmet ortağınız.",
    "Ihr Service rund um Nordzypern": "Kuzey Kıbrıs'taki hizmet ortağınız",
    "Ankommen. Entdecken. Entscheiden.": "Gelin. Keşfedin. Karar verin.",
    "UNSERE SERVICES ENTDECKEN": "HİZMETLERİMİZİ KEŞFEDİN",
    "PERSÖNLICHES GESPRÄCH": "BİZİMLE GÖRÜŞÜN",
    "Investments nur auf Anfrage.": "Yatırımlar yalnızca talep üzerine.",
    "Individuelle Konditionen.": "Size özel belirlenen koşullar.",
    "Investments ausschließlich auf Anfrage.": "Yatırımlar yalnızca talep üzerine.",
    "Ausschließlich auf Anfrage.": "Yalnızca talep üzerine.",
    "AUF ANFRAGE": "TALEP ÜZERİNE",
    "Individuell abgestimmte Konditionen.": "Size özel belirlenen koşullar.",
    "Auf Anfrage · individuelle Konditionen": "Talep üzerine · kişiye özel koşullar",
    "Immobilien": "Gayrimenkul",
    "Firmengründung": "Şirket Kuruluşu",
    "Bankkontoeröffnung": "Banka Hesabı Açılışı",
    "Banking": "Bankacılık",
    "Relocation": "Taşınma",
    "Angebote": "Paketler",
    "Ratgeber": "Rehber",
    "Nordzypern kennenlernen": "Kuzey Kıbrıs'ı Keşfedin",
    "Internationaler Umzugsservice": "Uluslararası Taşınma Hizmeti",
    "SETUP-CHECK": "ÖN DEĞERLENDİRME",
    "Kennenlern-Aufenthalt planen": "Keşif ziyaretinizi planlayın",
    "Ein Ansprechpartner.": "Tek bir iletişim noktası.",
    "Spezialisten für jeden Bereich.": "Her alanda uzman desteği.",
    "Services": "Hizmetler",
    "Immobilien kennenlernen": "Gayrimenkul seçeneklerini keşfedin",
    "Gründung besprechen": "Şirket kuruluşunu görüşelim",
    "Banking anfragen": "Bankacılık desteği talep edin",
    "Neustart planen": "Yeni başlangıcınızı planlayın",
    "ANFRAGE SENDEN": "TALEBİ GÖNDER",
    "Vielen Dank für Ihre Anfrage.": "Talebiniz için teşekkür ederiz.",
    "Investments.": "Yatırımlar.",
    "Investments": "Yatırımlar",
    "Home": "Ana Sayfa",
    "Close": "Kapat"
  }
} as const;
